import React, {Component} from "react"

import {StyledModal, Img} from "./styled"

interface Props {
  maxWidth: string,
  img: string,
  backdrop: string | boolean
}
interface State {
  isOpen: boolean
}

class PopUpWithImage extends Component<Props, State> {
  static defaultProps = {
    maxWidth: "450px",
    backdrop: "static"
  }

  state: State = {
    isOpen: false
  }

  close = () => {
    this.setState({isOpen: false})
  }

  open = () => {
    this.setState({isOpen: true})
  }

  render() {
    const {backdrop, children, img, maxWidth} = this.props
    return (
      <StyledModal
        show={this.state.isOpen}
        onHide={this.close}
        keyboard={false}
        backdrop={backdrop}
        maxWidth={maxWidth}>
        <div>
          {img && <Img src={img} alt="pop-up" />}
          {children}
        </div>
      </StyledModal>
    )
  }
}

export default PopUpWithImage
